import React, { useState, useRef, useEffect } from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { Calendar, X } from 'lucide-react'
import { formatDateToMMDDYYYY, isValidMMDDYYYY, parseMMDDYYYYDate } from './customDateFormatUtils'

const CustomDatePickingFormatForAddNewPatient = ({ value, onChange, disabled = false, maxDate = null }) => {
  const [inputValue, setInputValue] = useState(value || '')
  const [selectedDate, setSelectedDate] = useState(value && isValidMMDDYYYY(value) ? parseMMDDYYYYDate(value) : null)
  const [isOpen, setIsOpen] = useState(false)
  const inputRef = useRef(null)

  const handleDateChange = (date) => {
    const formatted = formatDateToMMDDYYYY(date)
    setSelectedDate(date)
    setInputValue(formatted)
    setIsOpen(false)
    onChange?.(formatted)
  }

  const handleBlur = () => {
    const trimmed = inputValue.trim()
    if (!trimmed) {
      onChange?.('')
      return
    }

    if (!isValidMMDDYYYY(trimmed)) {
      alert('Please enter a valid date in MM/DD/YYYY format.')
      setInputValue('')
      setSelectedDate(null)
      onChange?.('')
    }
    // else {
    //   const parsed = parseDate(trimmed)
    //   const formatted = formatDate(parsed)
    //   setSelectedDate(parsed)
    //   onChange?.(formatted)
    // }
    else {
      const parsed = parseMMDDYYYYDate(trimmed)

      if (maxDate && parsed > maxDate) {
        alert('Selected date is not allowed.')
        setInputValue('')
        setSelectedDate(null)
        onChange?.('')
        return
      }

      const formatted = formatDateToMMDDYYYY(parsed)
      setSelectedDate(parsed)
      onChange?.(formatted)
    }
  }

  const handleClear = () => {
    setInputValue('')
    setSelectedDate(null)
    setIsOpen(false)
    onChange?.('')
  }

  // const handleInputChange = (e) => {
  //   let val = e.target.value.replace(/[^\d]/g, '')

  //   if (val.length >= 3 && val.length <= 4) {
  //     val = `${val.slice(0, 2)}/${val.slice(2)}`
  //   } else if (val.length > 4) {
  //     val = `${val.slice(0, 2)}/${val.slice(2, 4)}/${val.slice(4, 8)}`
  //   }

  //   setInputValue(val)
  // }

  // solved:// when we dont focus outside it doesnt set the date
  const handleInputChange = (e) => {
    let val = e.target.value.replace(/[^\d]/g, '')

    if (val.length >= 3 && val.length <= 4) {
      val = `${val.slice(0, 2)}/${val.slice(2)}`
    } else if (val.length > 4) {
      val = `${val.slice(0, 2)}/${val.slice(2, 4)}/${val.slice(4, 8)}`
    }

    setInputValue(val)

    // if (isValidMMDDYYYY(val)) {
    //   const parsed = parseDate(val)
    //   setSelectedDate(parsed)
    //   onChange?.(formatDate(parsed))
    // }

    if (isValidMMDDYYYY(val)) {
      const parsed = parseMMDDYYYYDate(val)

      if (!maxDate || parsed <= maxDate) {
        setSelectedDate(parsed)
        onChange?.(formatDateToMMDDYYYY(parsed))
      }
    }
  }

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (inputRef.current && !inputRef.current.contains(e.target)) {
        setIsOpen(false)
        handleBlur()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [inputValue])

  useEffect(() => {
    if (value && isValidMMDDYYYY(value)) {
      const parsed = parseMMDDYYYYDate(value)
      setSelectedDate(parsed)
      setInputValue(formatDateToMMDDYYYY(parsed))
    }
  }, [value])

  return (
    <div ref={inputRef} className="datepicker-wrapper datepicker-wrapper--dark" style={{ width: '100%' }}>
      <div className="position-relative" style={{ width: '100%' }}>
        <input
          className="form-control pe-5 ui-date-input"
          value={inputValue}
          placeholder="MM/DD/YYYY"
          onChange={handleInputChange}
          onFocus={() => setIsOpen(false)}
          disabled={disabled}
        />

        {inputValue && (
          <X
            size={16}
            style={{
              position: 'absolute',
              top: '50%',
              right: '36px',
              transform: 'translateY(-50%)',
              cursor: 'pointer',
            }}
            className="ui-date-clear"
            onClick={handleClear}
            title="Clear date"
          />
        )}

        <Calendar
          size={18}
          style={{
            position: 'absolute',
            top: '50%',
            right: '12px',
            transform: 'translateY(-50%)',
            cursor: 'pointer',
          }}
          className="ui-date-calendar-icon"
          onClick={() => !disabled && setIsOpen(true)}
        />

        {isOpen && (
          <div className="ui-date-calendar-portal" style={{ position: 'absolute', zIndex: 999 }}>
            <DatePicker selected={selectedDate} onChange={handleDateChange} maxDate={maxDate} inline />
          </div>
        )}
      </div>
    </div>
  )
}

export default CustomDatePickingFormatForAddNewPatient
